import type { User } from 'models';

export const getEmail = (state: any) => {
  const {
    entities: {
      user: { email = null },
    },
  } = state;

  return email;
};

export const getUser = (state: any): User => {
  const {
    entities: { user },
  } = state;

  return user;
};

export const getCreditCards = (state: any) => {
  const { creditCards } = getUser(state);

  return creditCards || [];
};
